import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Button from "../../../../ui/Button";
import { EditIcon } from "../../../../utils/icon.utils";
import InventoryViewCard, { InventoryViewCardSkeleton } from "./InventoryViewCard";
import VehicleInventoryAccessories from "./VehicleInventoryAccessories";
import VehicleInventoryPrint from "./VehicleInventoryPrint";
import VehicleInventoryDate from "./VehicleInventoryDate";

export default function VehicleInventoryView({ data }) {
  const navigate = useNavigate();

  const attachment = data?.attachment;
  const inventoryDate = attachment?.inventoryDate;
  const importer = attachment?.importer;
  const receiver = data?.po_collector;
  const accessories = attachment?.accessories;

  const importerArr = [
    {
      label: "Name",
      value: importer?.name ?? "N/A"
    },
    {
      label: "Company",
      value: importer?.company?.label ?? "N/A"
    },
    {
      label: "Designation",
      value: importer?.designation ?? "N/A"
    },
    {
      label: "Mobile",
      value: importer?.mobile ?? "N/A"
    }
  ];

  const receiverArr = [
    {
      label: "Name",
      value: receiver?.name ?? "N/A"
    },
    {
      label: "Designation",
      value: receiver?.designation ?? "N/A"
    },
    {
      label: "Mobile",
      value: receiver?.mobile ?? "N/A"
    }
  ];

  // handle edit
  function handleEdit() {
    navigate(`/stock-list/inventory/${data?.caid ?? ""}/edit`);
  }

  return (
    <div className="bg-light rounded p-3">
      <div className="row g-3">
        <div className="col-12">
          <VehicleInventoryDate data={inventoryDate} />
        </div>
        <div className="col-12 col-md-6">
          <InventoryViewCard data={importerArr} title="Importer / Sender" />
        </div>

        <div className="col-12 col-md-6">
          <InventoryViewCard data={receiverArr} title="Receiver" />
        </div>

        <div className="col-12">
          <VehicleInventoryAccessories data={accessories} title="Accessories" />
        </div>

        <div className="col-12">
          <div className="text-end">
            <VehicleInventoryPrint data={data} />{" "}
            <Button onClick={handleEdit} name="Edit" icon={EditIcon} />
          </div>
        </div>
      </div>
    </div>
  );
}

// VehicleInventoryView skeleton
export function VehicleInventoryViewSkeleton() {
  return (
    <div className="bg-light rounded p-3">
      <p>
        <Skeleton width={`40%`} />
      </p>
      <div className="row">
        <div className="col-12 col-md-6">
          <InventoryViewCardSkeleton />
        </div>

        <div className="col-12 col-md-6">
          <InventoryViewCardSkeleton />
        </div>

        <div className="col-12">
          <div className="text-end">
            <Skeleton width={`10%`} height={30} />
          </div>
        </div>
      </div>
    </div>
  );
}
